import { motion } from "framer-motion";
import { MessageSquare, Search, Plane } from "lucide-react";

const STEPS = [
  {
    icon: MessageSquare,
    n: "01",
    title: "Tell us what you want",
    body:
      "Send a product link, screenshot, or simply describe the item. WhatsApp, email, or our order form — whichever you prefer.",
  },
  {
    icon: Search,
    n: "02",
    title: "We source & verify",
    body:
      "Our London team purchases from authorised UK retailers, quality-checks each piece, and photographs it before international dispatch.",
  },
  {
    icon: Plane,
    n: "03",
    title: "Delivered to you",
    body:
      "Air freight to Lagos with onward delivery to any Nigerian state. End-to-end in 7 to 10 working days, fully tracked.",
  },
];

export default function HowItWorks() {
  return (
    <section
      data-testid="how-it-works-section"
      className="bg-[#F8F5F0] py-24 md:py-32"
    >
      <div className="container-mps">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl mb-20"
        >
          <div className="overline text-[#C9A96E] mb-4">How It Works</div>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight">
            Three steps from{" "}
            <span className="italic text-[#C9A96E]">London to Lagos</span>.
          </h2>
          <div className="gold-divider mt-8" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`how-it-works-step-${s.n}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className="md:px-6 md:border-l border-[#E5E0D8] first:border-l-0"
            >
              <div className="font-serif text-7xl text-[#C9A96E]/30 leading-none mb-6">
                {s.n}
              </div>
              <s.icon className="text-[#C9A96E] mb-5" size={28} strokeWidth={1.4} />
              <h3 className="font-serif text-2xl md:text-3xl mb-4">{s.title}</h3>
              <p className="text-[#6B7280] leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
